// URL contract for opening Nexus with one or more objects pre-selected.
// BOLT (and Nexus "Copy Link") pass each object as a repeated `key` param:
// /explorer/<domain>/<space>?key=<s3-key>&key=<s3-key>

export function folderPrefixForKey(key: string): string {
  // A folder key ends with "/". Drop that slash first so the link opens the
  // folder that contains it, not the folder itself.
  const withoutOwnSlash = key.endsWith("/") ? key.slice(0, -1) : key;
  const slash = withoutOwnSlash.lastIndexOf("/");
  return slash >= 0 ? withoutOwnSlash.slice(0, slash + 1) : "";
}

// Open the folder that contains the first linked object. Keys that live in
// another folder are reported by the file list instead of being selected.
export function deepLinkFolderPrefix(keys: string[]): string {
  return keys.length ? folderPrefixForKey(keys[0]) : "";
}

export function parseDeepLinkKeys(search: string): string[] {
  const params = new URLSearchParams(search);
  const keys = params.getAll("key").filter(Boolean);
  return Array.from(new Set(keys));
}

export function buildObjectDeepLink(
  origin: string,
  domainName: string,
  spaceName: string,
  keys: string[],
): string {
  const query = keys
    .filter(Boolean)
    .map(key => `key=${encodeURIComponent(key)}`)
    .join("&");
  return `${origin}/explorer/${encodeURIComponent(domainName)}/${encodeURIComponent(spaceName)}${query ? `?${query}` : ""}`;
}
